module.exports = __webpack_public_path__ + "static/media/logo-footer.15e48836.svg";